import isNil from 'lodash/isNil';

import { TestType } from '@qality/common-model';

import { ALL_TEST_TYPES, TestTypeOption } from './TestTypeMultiSelect';

function mapTestTypesToSelectOptions(
  testTypes: Array<TestType>
): Array<TestTypeOption> {
  if (isNil(testTypes)) {
    return [ALL_TEST_TYPES];
  }
  const testTypesMap = new Map();

  testTypes
    .filter((testType) => testType !== null)
    .forEach((testType) => {
      if (!testTypesMap.has(testType.name)) {
        testTypesMap.set(testType.name, {
          label: testType.name,
          value: testType,
        });
      }
    });

  return Array.from(testTypesMap.values());
}

function mapSelectOptionsToTestTypes(
  testTypeOptions: Array<TestTypeOption>
): Array<TestType> {
  return filterOutAllTestTypesOption(testTypeOptions).map(
    (option) => option.value
  );
}

function filterOutAllTestTypesOption(
  options: Array<TestTypeOption>
): Array<TestTypeOption> {
  return options.filter((option) => option.value !== ALL_TEST_TYPES.value);
}

function getTestTypeOptions(testTypes: Array<TestType>): Array<TestTypeOption> {
  return [ALL_TEST_TYPES, ...mapTestTypesToSelectOptions(testTypes)];
}

export {
  mapTestTypesToSelectOptions,
  mapSelectOptionsToTestTypes,
  filterOutAllTestTypesOption,
  getTestTypeOptions,
};
